// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--UJWjl","description-wrapper":"_0fce717cdb--description-wrapper--TG2FU","button":"_0fce717cdb--button--cqi1U"};